/**
 * Full page navigation, bypassing the router. Reserved for the last resort: when in-page handling
 * of a link has already failed, the supporter still has to get where the link pointed.
 */
export function hardNavigate(url: string): void {
	window.location.assign(url);
}
